/**
 * Family-local mutation sync for OTK measure group lists (qlty008/011/012/013/014).
 *
 * Group rows are aggregates (count, MAX/MIN timestamps, correlated actors).
 * Prefer full progressive session restart over row patching for reliability.
 */

export const MEASURE_GROUPS_UPDATED_EVENT = 'measure_groups:updated';

export const SESSION_SAFE_UPDATE = 'SESSION_SAFE_UPDATE';
export const SESSION_INVALIDATING = 'SESSION_INVALIDATING';

/**
 * Remap group audit fields for tabulatorAuditColumns helpers.
 * Do NOT fall back to contractor as a fake audit user — null actors stay null.
 */
export function remapMeasureGroupAuditSource(row) {
  if (!row || typeof row !== 'object') {
    return {
      created_at: null,
      updated_at: null,
      created_by_user: null,
      updated_by_user: null,
    };
  }
  return {
    created_at: row.group_created_at ?? null,
    updated_at: row.group_updated_at ?? null,
    created_by_user: row.created_by_user ?? null,
    updated_by_user: row.updated_by_user ?? null,
  };
}

/**
 * Attach technical identity without inventing a visible measures.id.
 */
export function enrichMeasureGroupRows(rows, measureType) {
  if (!Array.isArray(rows)) return [];
  return rows.map((row) => {
    if (!row || typeof row !== 'object') return row;
    const orderNumber = row.order_number;
    const group_key = `measure-group:${String(measureType ?? '')}:${String(orderNumber ?? '')}`;
    return { ...row, group_key };
  });
}

/**
 * Aggregates always change on create/update — restart progressive session.
 * SESSION_SAFE_UPDATE is reserved for rare no-op acknowledgement only.
 */
export function classifyMeasureGroupListMutation(event, session = {}) {
  const detail = event?.detail;
  if (!detail || typeof detail !== 'object') return SESSION_INVALIDATING;
  if (detail.operation === 'noop') return null;

  const expectedType = session?.measureType;
  if (expectedType != null && detail.measureType != null && String(detail.measureType) !== String(expectedType)) {
    return null;
  }

  // Group grain aggregates (count / domain date / audit extrema) invalidate the session.
  return SESSION_INVALIDATING;
}

export function emitMeasureGroupListMutation(detail) {
  window.dispatchEvent(new CustomEvent(MEASURE_GROUPS_UPDATED_EVENT, {
    detail: detail && typeof detail === 'object'
      ? detail
      : { operation: 'invalidate' },
  }));
}
